import { render, staticRenderFns } from "./ThreadTopic.vue?vue&type=template&id=0cc8c581&scoped=true"
import script from "./ThreadTopic.vue?vue&type=script&lang=ts"
export * from "./ThreadTopic.vue?vue&type=script&lang=ts"
import style0 from "./ThreadTopic.vue?vue&type=style&index=0&id=0cc8c581&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc8c581",
  null
  
)

export default component.exports